import { observer } from "mobx-react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { useContext, useState } from "react";
import ToastContext from "../../components/toast/ToastContext";
import ContactGroupStore from "../../store/ContactGroupStore";
import UserDataStore from "../../store/UserDataStore";
import { ContactGroupToasts } from "../../toastMessages/contactGroupToastMessages";

export type AddContactGroupModalProps = {
  isVisible: boolean;
  closeModal: () => void;
  showLoader: React.Dispatch<React.SetStateAction<boolean>>;
};

const AddContactGroupModal: React.FC<AddContactGroupModalProps> = (props) => {
  const userData = UserDataStore.currentUser;

  const [label, setLabel] = useState<string>();
  const [description, setDescription] = useState<string>();
  const [labelInvalid, setLabelInvalid] = useState<boolean>(false);

  const showToast = useContext(ToastContext);

  const onClose = () => {
    setLabel(undefined);
    setDescription(undefined);
    props.closeModal();
  };

  const onSave = async () => {
    let error = false;
    if (!label) {
      error = true;
      setLabelInvalid(true);
    }
    if (error) return;
    props.showLoader(true);
    props.closeModal();
    if (!userData?.userId || !label) {
      console.error("undefined userId or label");
      return;
    }
    const { contactGroupCreated, contactGroupCreationError } =
      ContactGroupToasts;
    const creationSucceeded = await ContactGroupStore.addContactGroup({
      label: label!,
      description: description,
      contactIds: [],
    });
    showToast(
      creationSucceeded ? contactGroupCreated : contactGroupCreationError
    );
    if (creationSucceeded) {
      onClose();
    }
    props.showLoader(false);
  };

  const dialogFooter = () => {
    return (
      <>
        <Button label="Speichern" onClick={onSave} />
        <Button
          label="Abbrechen"
          className="p-button-secondary p-button-text"
          onClick={props.closeModal}
        />
      </>
    );
  };

  return (
    <Dialog
      visible={props.isVisible}
      header="Kontaktgruppe hinzufügen"
      modal
      className="p-fluid"
      footer={dialogFooter}
      onHide={onClose}
      style={{ width: "400px" }}
    >
      <div className="p-formgrid p-grid">
        <div className="p-field p-col-12">
          <label htmlFor="label">Ihre Bezeichnung</label>
          <InputText
            id="label"
            maxLength={32}
            value={label}
            placeholder="z.B. Management"
            onChange={(e) => {
              e.currentTarget.value && setLabelInvalid(false);
              setLabel(e.currentTarget.value);
            }}
          />
          {labelInvalid && (
            <small id="label" className="p-error p-d-block form-error">
              Bitte geben Sie der Kontaktgruppe eine Bezeichnung
            </small>
          )}
        </div>
        <div className="p-field p-col-12">
          <label htmlFor="description">Beschreibung</label>
          <InputText
            id="description"
            value={description}
            placeholder="z.B. Management der Abteilung 2"
            onChange={(e) => setDescription(e.currentTarget.value)}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default observer(AddContactGroupModal);
